module.exports = __webpack_public_path__ + "static/media/4554.5a194b6d.jpg";